module.exports = __webpack_public_path__ + "img/csv.1fd31361.svg";